// components/ScrollingPartners.js
import { motion } from "framer-motion";
import Mpw from "../assets/img/partner1.png";

const schoolLogos = [
  { id: 1, src: "https://www.intoglobal.com/images/into-logo.png", alt: "intoglobal" },
  { id: 2, src: "https://www.oncampus.global/themes/custom/oncampus/assets/img/logo.svg", alt: "oncampus" },
  { id: 3, src: "https://www.markbrookseducation.com/wp-content/uploads/2022/12/Padworth-College-Logo_Globe-on-LHS.png", alt: "Padworth-College" },
  { id: 4, src: Mpw, alt: "mpw" },
  { id: 5, src: "https://static.wixstatic.com/media/18301c_15548beb046d423b9111a902aec8784d~mv2.gif", alt: "david games" },
  { id: 6, src: "https://www.catscambridge.com/wp-content/uploads/2022/09/CATS-Cambridge-Logo.png", alt: "CATS" },
  { id: 7, src: "https://braemarcollege.com/wp-content/uploads/2021/04/BC-LOGO-768x243-1.png", alt: "braemarcollege" },
  { id: 8, src: "https://upload.wikimedia.org/wikipedia/commons/7/75/NAE_logo.png", alt: "nord anglia" },
  { id: 9, src: "https://media.licdn.com/dms/image/v2/C4E12AQHv0LkE8_DW2Q/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1549473560581?e=2147483647&v=beta&t=Qik4jip9aEiQzjGOF1wrZI3a0qflhRXVlUCp2mrnYZU", alt: "amerigo" },
  { id: 10, src: "https://pure.sruc.ac.uk/skin/headerImage/", alt: "sruc" },
  { id: 11, src: "https://gescoedu.com/wp-content/uploads/2022/08/gus.png", alt: "gus" },
  { id: 12, src: "https://cdn.prod.website-files.com/649b607cb9ec684ae7c02cbd/649b607cb9ec684ae7c02d77_UCW_LOGO.jpg", alt: "University canada west" },
  { id: 13, src: "https://cdn.freelogovectors.net/wp-content/uploads/2021/02/niagara-university-logo-freelogovectors.net_.png", alt: "niagara-university" },
  { id: 14, src: "https://adventus.io/wp-content/uploads/2022/01/image-3.png", alt: "shorelight" },
  { id: 15, src: "https://seeklogo.com/images/S/st-george-s-university-logo-DBA0226300-seeklogo.com.png", alt: "St George University" },
  { id: 16, src: "https://tgmeducation.com/wp-content/uploads/2020/07/american_university_of_barbados.jpg", alt: "St George University" },
  { id: 17, src: "https://keystoneacademic-res.cloudinary.com/image/upload/element/12/124054_ac-logo.jpg", alt: "alexander college" },
];

const ScrollingPartners = () => {
  return (
    <div className="relative py-8 mt-2">
      <div className="relative flex flex-col gap-16 h-full md:min-h-64">
        {/* First Row */}
        <div className="flex">
          <motion.div
            className="flex flex-wrap flex-shrink-0 animate-scroll"
            initial={{ x: 0 }}
            animate={{ x: "-100%" }}
            transition={{ repeat: Infinity, duration: 40, ease: "linear" }}
          >
            {schoolLogos.map((logo) => (
              <img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className="w-24 sm:w-72 h-12 sm:h-36 mr-8 p-3"
              />
            ))}
          </motion.div>

          <motion.div
            className="flex flex-wrap flex-shrink-0 animate-scroll"
            initial={{ x: 0 }}
            animate={{ x: "-100%" }}
            transition={{ repeat: Infinity, duration: 40, ease: "linear" }}
          >
            {schoolLogos.map((logo) => (
              <img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className="w-24 sm:w-72 h-12 sm:h-36 mr-8 p-3"
              />
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ScrollingPartners;
